import Movedelete from "./leftMoveDelete";

function install(vue) {
  vue.directive("Movedelete", Movedelete);
}
if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}
Movedelete.install = install;
export default Movedelete;
